module.exports = __webpack_public_path__ + "img/KeryxWebpage.2761caff.png";